/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cap_1_DescInputs */

const en_mk_cap_1_desc = /** @type {(inputs: Mk_Cap_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A list to work in, a board to see the flow, a table to audit. Your choice is remembered per page.`)
};

const id_mk_cap_1_desc = /** @type {(inputs: Mk_Cap_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar untuk mengerjakan, papan untuk melihat aliran, tabel untuk memeriksa. Pilihan tampilan diingat per halaman.`)
};

/**
* | output |
* | --- |
* | "A list to work in, a board to see the flow, a table to audit. Your choice is remembered per page." |
*
* @param {Mk_Cap_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cap_1_desc = /** @type {((inputs?: Mk_Cap_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cap_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cap_1_desc(inputs)
	return en_mk_cap_1_desc(inputs)
});